import {ADD_FOLDER, ADD_TEMPLATE, DELETE_FOLDER, DELETE_TEMPLATE, RENAME_FOLDER, EDIT_TEMPLATE, CLEAR_SETTING_VIEWER} from "../constans";
import {
  addTemplateFolder,
  deleteTemplate, deleteTemplateFolder,
  editTemplate,
  renameTemplateFolder,
  saveTemplate
} from "../../utils/builder/IScheduleLogic";

export const addFolderTemplate = (res) => async (dispatch) => {
  await addTemplateFolder(res);

  dispatch({
    type: ADD_FOLDER,
    payload: res,
  });
};

export const renameFolderTemplate = (originalName, newNameFolder) => async (dispatch) => {
  renameTemplateFolder(originalName, newNameFolder);

  dispatch({
    type: RENAME_FOLDER,
    payload: {
      newNameFolder: newNameFolder,
      originalName: originalName
    },
  });
};

export const addTemplate = (res) => async (dispatch) => {

  const { folder, template, description, properties, group, } = res;

  await saveTemplate(folder, template, description, properties, group, "");

  dispatch({
    type: ADD_TEMPLATE,
    payload: res,
  });
};

export const templateEdit = (res) => async (dispatch) => {

  const { currentNameFolder, currentNameTemplate, newNameFolder, newNameTemplate, newDescriptionTemplate } = res;

  await editTemplate(currentNameFolder, currentNameTemplate, newNameFolder, newNameTemplate, newDescriptionTemplate);

  dispatch({
    type: EDIT_TEMPLATE,
    payload: res,
  });
};

export const deleteFolderTemplate = (res) => async (dispatch) => {
  deleteTemplateFolder(res);

  dispatch({
    type: DELETE_FOLDER,
    payload: res,
  });
};

export const deleteTemplateFromFolder = (folderName, templateName) => async (dispatch) => {

  await deleteTemplate(folderName, templateName);

  dispatch({
    type: DELETE_TEMPLATE,
    payload: {
      folderName: folderName,
      templateName: templateName
    },
  });
};

export const clearSettingViewer = () => {

  return {
    type: CLEAR_SETTING_VIEWER,
  };
};
